// extracted by mini-css-extract-plugin
module.exports = {"option":"TriageOption_option__THcCC","avatar":"TriageOption_avatar__KyJ2L","values":"TriageOption_values__3bQOd"};